export const locale = {
    lang: 'en',
    data: {
        'TITLE': {
        },
        'FIELDS': {
            'IsSendEmail': 'Is Send Email ?',
            'TabList': 'Tab list setting',
            'UseNanoLink': 'Use Nano Link',
            'NanolinkSetting':'Nano link settings',
            'SMSSignature': 'SMS signature',
            'AdditionalMenus': 'Add New Menus',
            'RedirectingURL': 'Redirecting URL',
            'MenuName': 'Menu Name',
            'WorkingStatus': 'Working Status',
        },
        'Message': {

        },
        'FILTERS': {
        },
        'moduleTypeList': {
        },
        'BUTTONS': {
            'Save':'Save',
        },
        'TOOLTIP':{
            'AddMenu': 'Add New Menu',
            'DeleleMenu': 'Delete Menu'
        }
    }
};